module.exports = __webpack_public_path__ + "media/images/Enchanted Kingdom-8f4004408c79cd720997b8b2744ff5e3.png";